import { Component, ElementRef, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-accept-reject-dialog',
  templateUrl: './accept-reject-dialog.component.html',
  standalone: true, 
  imports: [
    MatDialogModule, MatButtonModule
  ],
  styleUrls: ['./accept-reject-dialog.component.scss']
})
export class AcceptRejectDialogComponent implements OnInit {
  message: string;
  constructor(public dialogRef: MatDialogRef<AcceptRejectDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: string) { 
    this.message = data;

  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
